import { createListReducer } from 'Services/reducerCreator';

export default createListReducer('LINEUP_SURVEY_LIST');
